// Shared with the withdrawal step, which also moves focus on mount.
export const scrollToTop = () => {
  window.scrollTo(0, 0);
  if (window.parent !== window) {
    window.parent.postMessage(JSON.stringify({ type: 'scrollToTop' }), '*');
  }
};
